// class helper functions
const removeClass = (el, classname) => {
    el.className = el.className.replace(" " + classname, "");
    el.className = el.className.replace(classname, "");
}
const addClass = (el, classname) => {
    if (!hasClass(el, classname)) {
        el.className += " " + classname;
    }
}
const hasClass = (el, classname) => {
    return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);
}

document.addEventListener('DOMContentLoaded', () => {
    

    // function to go through an HTMLCollection of dialog elements and bind close or open events of them
    const openOrClose = (elements, behavior) => {
        [].forEach.call(elements, element => {
            element.addEventListener('click', e => {
                
                // grab all accordions
                const accordions = document.querySelectorAll('.wp-block-mu-accordion');

                // go through each accordion. 
                [].some.call(accordions, accordion => {

                    // if accordion appears before our button, skip this accordion
                    if (element.compareDocumentPosition(accordion) & Node.DOCUMENT_POSITION_PRECEDING) {
                        return false;
                    }

                    // grab the accordion's detail element
                    const details = accordion.querySelector('details');

                    // open or close the accordion until we get up to one with no proceeding accordion
                    if (behavior == 'open') {
                        details.open = true;
                        details.setAttribute('open', 'open');
                        if (
                            !accordion.nextElementSibling ||
                            accordion.nextElementSibling.className.match(/wp-block-mu-accordion/) == null 
                        ) {
                            return true;
                        }
                    } else if (behavior == 'close') {
                        details.open = false;
                        details.removeAttribute('open')
                        if (
                            !accordion.nextElementSibling ||
                            accordion.nextElementSibling.className.match(/wp-block-mu-accordion/) == null
                        ) {
                            return true;
                        }
                    }
                });
            });
        });
    }

    // grab all instances of accordion expand and collapse buttons
    const expanders = document.querySelectorAll('button.accordion-selector-expand');
    const collapsers = document.querySelectorAll('button.accordion-selector-collapse');

    // stop if there are none
    if (!expanders || !collapsers) {
        return;
    }

    // go through each expander and collapser calling array's forEach method on the HTMLCollection
    openOrClose(expanders, 'open');
    openOrClose(collapsers, 'close');

    // add activated class or remove it when expander or collapser gets clicked
    [].forEach.call(expanders, expander => {
        expander.addEventListener('click', e => {
            addClass(e.currentTarget, 'activated')
            removeClass(e.currentTarget.nextElementSibling, 'activated');
        })
    });
    [].forEach.call(collapsers, collapser => {
        collapser.addEventListener('click', e => {
            addClass(e.currentTarget, 'activated')
            removeClass(e.currentTarget.previousElementSibling, 'activated');
        })
    })

});
